/**
 * 지점 포털 판별
 *
 * 두 가지 방식으로 붙는다.
 *   1. 전용 도메인      wonil.likeweb.co.kr/ (개발), wonil.coryo1.co.kr/ (운영)
 *                      → 루트가 곧 포털이라 경로 접두사가 없다
 *   2. 본점 도메인 경로  coryodnl.likeweb.co.kr/branch → /branch 접두사를 붙인다
 *
 * 앱 로드 시점의 hostname/pathname 으로 결정되며, 인증 스토어의 persist key 와
 * 401 리다이렉트 경로가 이 값을 따른다.
 * (콘솔 ↔ 지점 이동은 클라이언트 라우팅이 아니라 전체 새로고침으로 처리해야 키가 다시 잡힌다)
 */
const PORTAL_HOSTS = ["wonil.likeweb.co.kr", "wonil.coryo1.co.kr"];

/** 전용 도메인으로 들어왔는지 */
export const IS_PORTAL_HOST = PORTAL_HOSTS.includes(window.location.hostname);

export const IS_BRANCH_PORTAL = IS_PORTAL_HOST || window.location.pathname.startsWith("/branch");

/** 지점 화면의 경로 접두사. 전용 도메인이면 비어 있다 */
export const BRANCH_BASE_PATH = IS_PORTAL_HOST ? "" : "/branch";

/** 콘솔/지점 각각의 로그인 화면 경로 */
export const LOGIN_PATH = IS_BRANCH_PORTAL ? BRANCH_BASE_PATH || "/" : "/console";

/** 로그인 성공 후 이동할 경로 */
export const HOME_PATH = IS_BRANCH_PORTAL ? `${BRANCH_BASE_PATH}/transaction` : "/console/transaction";
